import { Component, OnInit } from '@angular/core';
import { CognitoService, User } from '../authentication/cognito.service';

@Component({
  selector: 'nw-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
  loading: boolean;
  user: User;

  constructor(private cognitoService: CognitoService) {
    this.loading = false;
    this.user = {} as User;
  }

  public ngOnInit(): void {
    this.cognitoService.getUser().then((user: any) => {
      this.user = user.attributes;
    });
  }

  public update(): void {
    this.loading = true;

    this.cognitoService
      .updateUser(this.user)
      .then(() => {
        this.loading = false;
        console.log('User data updated ', this.user);
      })
      .catch(() => {
        this.loading = false;
      });
  }
}
